import { Configuration, PopupRequest } from '@azure/msal-browser'

// Hodnoty doplňte z Azure Entra ID app registration
export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_MSAL_CLIENT_ID ?? 'YOUR_SPA_CLIENT_ID',
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_MSAL_TENANT_ID ?? 'YOUR_TENANT_ID'}`,
    redirectUri: import.meta.env.VITE_MSAL_REDIRECT_URI ?? 'http://localhost:5173',
  },
  cache: {
    // localStorage sdílí přihlášení mezi kartami (SSO) — nová karta (Ctrl+klik) nevyžaduje nový login.
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
}

export const loginRequest: PopupRequest = {
  scopes: [`api://${import.meta.env.VITE_API_CLIENT_ID ?? 'YOUR_API_CLIENT_ID'}/access_as_user`],
}

export const graphRequest = {
  scopes: ['User.ReadBasic.All'],
}

export const apiConfig = {
  baseUrl: import.meta.env.VITE_API_BASE_URL ?? '/api',
}
